export function getEtherscanTransactionLink(transactionHash: string) {
  return `https://etherscan.io/tx/${transactionHash}`;
}

export function addressStartAndEnd(str: string) {
  if (str.length > 20)
    return str.substr(0, 16) + '...' + str.substr(str.length - 4, str.length);
  return str;
}
